$(document).ready(function (params) {
  $(document).on('click', '.metafield-product-swatch', function () {
    var url = $(this).data('product_url');
    $("#MainContent").load(`${url}?view=color-swatch`);
  });
  $('.mobile-facets__main details.mobile-facets__details[data-index="mobile-1"] .mobile-facets__submenu ul.mobile-facets__list li.mobile-facets__item label.mobile-facets__label[title="In stock"]').trigger('click');
  $('.add-to-cart-dock-btn').on('click', function (e) {
    e.preventDefault();
    $('.product-form__submit').trigger('click');
  });
  $('#mobile-dock-buy-now-btn').on('click', function (e) {
    e.preventDefault();
    $('#flo-buy-now-btn').trigger('click');
  });
});

(function () {

  $('.filter_custom li').on('click', function (e) {
    e.preventDefault();
    var tag = $(this).attr('data-tag');
    if ($(this).hasClass('active_filter')) {
      $(this).removeClass('active_filter');
      $('.mobile-facets__submenu li input[data-value="' + tag + '"]').closest('label').trigger('click');
    } else {
      $(this).addClass('active_filter');
      $('.mobile-facets__submenu li input[data-value="' + tag + '"]').closest('label').trigger('click');
    }
    return false;
  })

  $('.mobile-facets__submenu li input').each(function (e) {
    if ($(this).prop('checked')) {
      var tag = $(this).attr('data-value');
      $('.filter_custom li[data-tag="' + tag + '"]').addClass('active_filter');
    } else {
      var tag = $(this).attr('data-value');
      $('.filter_custom li[data-tag="' + tag + '"]').removeClass('active_filter');
    }
  })

  var addOnSlider = function () {
    $('.productAddon__slider').flickity({
      cellAlign: 'left',
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: true
    })
  };

  var addOnCart = function () {

    $('.js-variants').on('change', function () {
      var val = $(this).val();
      //console.log(val);
      var parent = $(this).parents('.productAddon__item');
      var optionIndex = $(this).parents('.product-form__option').data('option-index');
      var otherVal = []
      var dropDownLength = parent.find('.js-variants').not(this).length;
      var colorSwatchLength = parent.find('.metafield-product-swatch.active').not(this).length;
      console.log(dropDownLength, '--dropDownLength');
      console.log(colorSwatchLength, '--colorSwatchLength');
      if (colorSwatchLength > 0 || dropDownLength > 0) {
        parent.find('.js-variants').not(this).each(function () {
          otherVal.push($(this).val());
        });
        parent.find('.metafield-color-swatches').each(function () {
          otherVal.push($(this).find('.metafield-product-swatch.active').data('value'));
        });
      }
      console.log(optionIndex + '-- Option Index');
      console.log(otherVal + '-- OptionValues');
      if (otherVal.length == 1) {
        if (optionIndex == 1) {
          var finalVal = val + ' / ' + otherVal[0];
        } else if (optionIndex == 2) {
          var finalVal = otherVal[0] + ' / ' + val;
        }
      } else if (otherVal.length == 2) {
        if (optionIndex == 1) {
          var finalVal = val + ' / ' + otherVal[0] + ' / ' + otherVal[1];
        } else if (optionIndex == 2) {
          var finalVal = otherVal[0] + ' / ' + val + ' / ' + otherVal[1];
        } else if (optionIndex == 3) {
          var finalVal = otherVal[0] + ' / ' + otherVal[1] + ' / ' + val;
        }
      } else {
        var finalVal = val;
      }
      console.log(finalVal, "--Fianl value");

      var VariantVal = parent.find('.product__var-id[data-title="' + finalVal + '"]').data('var-id');
      parent.find('.button.ctm_Addon-cart').attr('data-val', VariantVal);
      console.log(VariantVal);
    });

    $(document).on('click', '.ctm_Addon-cart', function () {
      var variantId = $(this).attr('data-val');

      var miniCart = document.querySelector('mini-cart');

      if (variantId) {
        if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
          Shopify.postLink(window.routes.cart_add_url, {
            parameters: {
              id: variantId,
              quantity: 1
            },
          });
          return;
        }

        const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
        const body = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname
        });

        fetch(`${window.routes.cart_add_url}`, {
            ...fetchConfig('javascript'),
            body
          })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status === 422) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
            } else {
              miniCart && miniCart.renderContents(parsedState);

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: parsedState
                }
              }));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            console.log("Product is added")
          });
      }
    });

    $(document).on('click', '.grid__item .card__colors .color-swatch', function (e) {
      e.preventDefault();
      var variantId = $(this).attr('data-variant-id');
      console.log('13456 test');
      var miniCart = document.querySelector('mini-cart');

      if (variantId) {
        if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
          Shopify.postLink(window.routes.cart_add_url, {
            parameters: {
              id: variantId,
              quantity: 1
            },
          });
          return;
        }

        const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
        const body = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname
        });

        fetch(`${window.routes.cart_add_url}`, {
            ...fetchConfig('javascript'),
            body
          })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status === 422) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
            } else {
              $('body').addClass('added_cart_active');
              miniCart && miniCart.renderContents(parsedState);

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: parsedState
                }
              }));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            console.log("Product is added");
            $('.box-popup-col-card').removeClass('popup-visible');
            $('details.cart-drawer-container').addClass('menu-opening');
            $('details.cart-drawer-container').prop('open', true);
            $('body').addClass('mini-cart--open');
          });
      }
      return false;
    })
  };

  addOnSlider();
  addOnCart();

  $(document).on('shopify:section:load', function (event) {
    addOnSlider();
    addOnCart();
  });

  $(document).on('change', '.variant-options input[type="radio"]', function () {
    const $container = $(this).closest('.variant-options');
    const productId = $container.data('product-id');
    const allVariants = JSON.parse($container.attr('data-variants'));
  
    let selectedOptions = [];
  
    // Collect selected values from all option groups
    $container.find('.popup-option-group').each(function () {
      const index = $(this).data('option-index');
      const selectedInput = $(this).find('input[type="radio"]:checked');
      selectedOptions[index] = selectedInput.val();
    });
  
    // Match selected options with variant
    let matchedVariant = allVariants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return selectedOptions[i] === undefined || selectedOptions[i] === opt;
      });
    });
  
    // If matching variant is found
    if (matchedVariant) {
      updateOptionStates($container, allVariants, selectedOptions);
  
      if (matchedVariant.available) {
        const totalGroups = $container.find('.popup-option-group').length;
        const selectedCount = selectedOptions.filter(v => v !== undefined).length;
  
        if (selectedCount === totalGroups || totalGroups === 1) {
          addToCart(matchedVariant.id);
        }
      }
    }
  });
  
  // Add to cart function
  function addToCart(variantId) {
    var miniCart = document.querySelector('mini-cart');
    const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];

    fetch(window.routes.cart_add_url, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
    .then(res => res.json())
    .then(parsedState => {
      console.log('Product added to cart:', variantId);
      $('body').addClass('added_cart_active');
      miniCart && miniCart.renderContents(parsedState);

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: parsedState }
      }));
    })
    .catch(err => {
      console.error('Add to cart failed:', err);
    })
    .finally(() => {
      console.log("Product is added");
      $('.box-popup-col-card').removeClass('popup-visible');
      $('details.cart-drawer-container').addClass('menu-opening');
      $('details.cart-drawer-container').prop('open', true);
      $('body').addClass('mini-cart--open');
    });
  }

  // Disable unavailable option combinations
  function updateOptionStates($container, allVariants, selectedOptions) {
    $container.find('.popup-option-group').each(function () {
      const groupIndex = $(this).data('option-index');
  
      $(this).find('input[type="radio"]').each(function () {
        const value = $(this).val();
        const testCombo = [...selectedOptions];
        testCombo[groupIndex] = value;
  
        const valid = allVariants.some(v => {
          return v.available && v.options.every((opt, i) => {
            return testCombo[i] === undefined || testCombo[i] === opt;
          });
        });
  
        const label = $(this).next('label');
        if (!valid) {
          $(this).prop('disabled', true);
          label.addClass('disabled');
        } else {
          $(this).prop('disabled', false);
          label.removeClass('disabled');
        }
      });
    });
  }
}());


var swiper = new Swiper('.home-more-collection-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }
});


$(document).ready(function () {

  //alert('here');

  $('.tabs a').click(function () {

    $('.panel').hide();
    $('.tabs a.active').removeClass('active');
    $(this).addClass('active');

    var panel = $(this).attr('href');
    $(panel).fadeIn(1000);

    return false; // prevents link action

  }); // end click 

  $('.tabs li:first a').click();

}); // end ready

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    if (event.target.matches('.var-popup-trigger') || event.target.closest('.var-popup-trigger')) {
      event.preventDefault();
      event.stopPropagation();

      const trigger = event.target.closest('.var-popup-trigger');
      const cardWrapper = trigger.closest('.card-wrapper');

      if (cardWrapper) {
        const popupBox = cardWrapper.querySelector('.box-popup-col-card');
        if (popupBox) {
          popupBox.classList.add('popup-visible');
        } else {
          console.warn('No .box-popup-col-card found inside .card-wrapper');
        }
      } else {
        console.warn('No .card-wrapper found for the clicked trigger');
      }
    }
  });
});

$('span.close-var-popup').on('click', function () {
  $(this).parent('.box-popup-col-card').removeClass('popup-visible');
});


function copyToClipboard(element) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
}

document.addEventListener("DOMContentLoaded", function () {
  $(".copy-code").click(function () {
    var $clickedElement = $(this);
    var $strongElement = $clickedElement.find('strong');

    // Check if the clicked element already has the "active" class
    if ($clickedElement.hasClass("active")) {
      // Clicked element already active, remove the class
      $clickedElement.removeClass("active");
    } else {
      // Clicked element not active, add the class and remove from others
      $(".copy-code").removeClass("active");
      $clickedElement.addClass("active");

      // Additional actions or modifications
      console.log("Strong element is now active");

      // Call the copyToClipboard function passing the 'strong' element
      copyToClipboard($strongElement);
    }
  })
});


if ($(window).width() < 749) {
  $(".appbrew-mobile").append($("#appbrew-download-banner-root"));
}


document.querySelectorAll('.code-copy button').forEach(function (button) {
  button.addEventListener('click', function () {
    // Get the code text from the sibling element with ID "myInput"
    const codeText = this.closest('.code-copy').querySelector('.cart-code').innerText.trim();

    navigator.clipboard.writeText(codeText).then(function () {
      showCopyToast(); // Show the bottom popup
    }, function (err) {
      console.error('Failed to copy text: ', err);
    });
  });
});


function showCopyToast() {
  const toast = document.getElementById('copy-toast');
  toast.style.display = 'block';
  toast.style.opacity = '1';

  setTimeout(function () {
    toast.style.opacity = '0';
    setTimeout(() => {
      toast.style.display = 'none';
    }, 300);
  }, 2000);
}